import LegalLayout, { Section, LEGAL_CONTACT } from "@/components/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout
      eyebrow="Legal"
      title="PRIVACY POLICY."
      intro="We collect the minimum data needed to deliver your powders and run this store honestly. This policy explains what we collect, why, and the choices you have."
    >
      <Section title="What we collect">
        <p><strong>Order information:</strong> name, phone number, email, delivery address and order contents — so we can deliver and support your order.</p>
        <p><strong>Account information:</strong> if you create an account, your name, email and a securely hashed password (or your Google profile name, email and picture if you sign in with Google).</p>
        <p><strong>Payment information:</strong> handled entirely by Razorpay. We never see or store your full card number, CVV or UPI PIN.</p>
        <p><strong>Business enquiries:</strong> the details you share in our contact or distributor forms.</p>
      </Section>

      <Section title="How we use it">
        <p>To process and deliver orders, send order updates and confirmations, provide support on call/WhatsApp/email, run the account area, and improve the store. We may contact you about your order by call, WhatsApp, SMS or email.</p>
        <p>If you join our newsletter, we email occasional brand updates. Every such email carries an unsubscribe option — or email us and we will remove you.</p>
      </Section>

      <Section title="What we never do">
        <p>We do not sell or rent your personal data. We do not send you marketing messages unless you opted in. We never ask for your password, OTP or card details by email, phone or WhatsApp — if someone does, it is not us.</p>
      </Section>

      <Section title="Sharing">
        <p>We share only what is necessary: your delivery details with our courier partners, your payment with Razorpay (our PCI-DSS compliant gateway), and service providers who host our systems. All are bound to use your data only for our services to you.</p>
        <p>We may disclose data if required by law or to protect our rights.</p>
      </Section>

      <Section title="Storage and security">
        <p>Data is stored on secured infrastructure with access limited to team members who need it. Passwords are hashed (bcrypt) and sessions use secure, httpOnly cookies. We retain order records for accounting and legal compliance, and delete accounts on verified request.</p>
      </Section>

      <Section title="Cookies">
        <p>We use a small set of essential cookies: cart contents, your login session, and your coupon preferences. No third-party advertising trackers are used today.</p>
      </Section>

      <Section title="Your rights">
        <p>Email {LEGAL_CONTACT.email} to access, correct or delete your data, or to withdraw a newsletter consent. We act on verified requests within 30 days.</p>
      </Section>

      <Section title="Grievance officer">
        <p>Grievance Officer: Proprietor, {LEGAL_CONTACT.entity} — {LEGAL_CONTACT.email}, {LEGAL_CONTACT.phone}. We respond within 48 hours.</p>
      </Section>
    </LegalLayout>
  );
}
